import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import nl from 'vuetify/es5/locale/nl';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        values: {
            warning: 'mdi-alert',
            error: 'mdi-alert-octagon',
        }
    },
    theme: {
        light: true,
        options: {
            // DOC: https://vuetifyjs.com/en/customization/theme/#custom-properties
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#2091b3',
                secondary: '#7dafcd', // #98aebb
                accent: '#FF5722', // FF5722, B36F2C, B31241, 30A9CC
                error: '#B31241',
                info: '#006383',
                success: '#20b34d', // 1b9638
                warning: '#FFAF61', // FFAF61 ffa800
            },
            dark: {
                primary: '#2091b3',
                secondary: '#7dafcd', // #98aebb
                accent: '#FF5722', // FF5722, B36F2C, B31241, 30A9CC
                error: '#B31241',
                info: '#006383',
                success: '#20b34d', // 1b9638
                warning: '#FFAF61', // FFAF61 ffa800
            },
        },
    },
    lang: {
        locales: {nl},
        current: 'nl',
    },
});
